import API from 'api/hallomart';
import { REQUEST_FUNDS_OK } from 'modules/requestFunds';

/**
 * Constants
 */

export const FETCH_PAYOUT = 'payout/FETCH_PAYOUT';
export const FETCH_PAYOUT_OK = 'payout/FETCH_PAYOUT_OK';
export const FETCH_PAYOUT_FAILED = 'payout/FETCH_PAYOUT_FAILED';

/**
 * Action Creators
 */

export function fetchPayout(args = {}) {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_PAYOUT });
      const payout = await API.getPayoutHistory(args);
      dispatch({
        type: FETCH_PAYOUT_OK,
        payout: payout.data,
        totalPages: parseInt(payout.headers['x-wp-totalpages'], 10),
      });
    } catch (err) {
      dispatch({ type: FETCH_PAYOUT_FAILED, error: err.response || err.message });
    }
  };
}

/**
 * Reducers
 */

const initialState = {
  isLoading: false,
  error: false,
  errors: {},
  payout: [],
  totalPages: 1,
};

export default function payout(state = initialState, action) {
  switch (action.type) {
    case FETCH_PAYOUT:
      return {
        ...state,
        error: false,
        errors: {},
        isLoading: true,
      };

    case FETCH_PAYOUT_OK:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        payout: action.payout,
        totalPages: action.totalPages,
      };

    case FETCH_PAYOUT_FAILED:
      return {
        ...state,
        isLoading: false,
        error: true,
        errors: action.error,
      };

    case REQUEST_FUNDS_OK:
      return {
        ...state,
        payout: [action.payload, ...state.payout],
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/payout.js